<template>
  <div class="gb-page">
    <HeadNav selectedLanguage="en" page="update" />
    <BreadcrumbNav :items="[{ label: 'Update' }]" />

    <main>
      <section class="update-hero">
        <div class="hero-bg" aria-hidden="true" />
        <div class="page-shell hero-grid">
          <div class="hero-copy">
            <p class="eyebrow">
              <span class="eyebrow-dot" />
              Latest update
            </p>
            <h1>GB WhatsApp Update: Download the Latest Version</h1>
            <p class="hero-lead">{{ copy.hero }}</p>
            <a class="primary-btn" :href="downloadUrl">
              Download Latest Update
            </a>
          </div>
          <aside class="update-card" aria-label="Latest GB WhatsApp version">
            <span>Latest Version</span>
            <strong>{{ app.latestVersion }}</strong>
            <p>Release time: {{ app.releaseMonth }}</p>
            <a class="card-link" :href="downloadUrl">
              Get update APK
            </a>
          </aside>
        </div>
      </section>

      <section class="content-section">
        <div class="page-shell split-section">
          <div>
            <p class="section-kicker">Update download</p>
            <h2>Download the Latest GB WhatsApp Update</h2>
            <p>
              The latest
              <router-link class="home-text-link" :to="{ name: 'en-gb' }">
                GB WhatsApp
              </router-link>
              update listed on this website is
              {{ app.latestVersion }}. The release time shown for this update is
              {{ app.releaseMonth }}.
            </p>
            <p v-for="(text, idx) in copy.section1" :key="`u1-${idx}`">{{ text }}</p>
          </div>
          <div class="info-panel">
            <div class="info-panel-header">
              <p>Update details</p>
              <strong>{{ app.latestVersion }}</strong>
            </div>
            <table>
              <tbody>
                <tr>
                  <th>Latest Version</th>
                  <td>{{ app.latestVersion }}</td>
                </tr>
                <tr>
                  <th>Release Time</th>
                  <td>{{ app.releaseMonth }}</td>
                </tr>
                <tr>
                  <th>File Type</th>
                  <td>{{ app.fileType }}</td>
                </tr>
                <tr>
                  <th>Platform</th>
                  <td>{{ app.platform }}</td>
                </tr>
                <tr>
                  <th>File Size</th>
                  <td>{{ app.fileSize }}</td>
                </tr>
              </tbody>
            </table>
            <a class="table-btn" :href="downloadUrl">
              Download
            </a>
          </div>
        </div>
      </section>

      <section class="content-section muted">
        <div class="page-shell">
          <p class="section-kicker">Update highlights</p>
          <h2>What's New in the Latest GB WhatsApp Update</h2>
          <p class="section-lead">{{ copy.section2Intro }}</p>
          <div class="highlight-grid">
            <article v-for="(item, idx) in highlights" :key="item[0]" class="highlight-card">
              <span class="highlight-index">0{{ idx + 1 }}</span>
              <h3>{{ item[0] }}</h3>
              <p>{{ item[1] }}</p>
            </article>
          </div>
        </div>
      </section>

      <section class="content-section steps-section">
        <div class="page-shell">
          <header class="steps-header">
            <p class="section-kicker">Update guide</p>
            <h2>How to Update GB WhatsApp Without Losing Chats</h2>
            <p v-for="(text, idx) in copy.section3" :key="`u3-${idx}`">{{ text }}</p>
          </header>
          <ol class="update-panel">
            <li>
              <span class="step-num">1</span>
              <div>
                <strong>Backup</strong>
                <p>Backup important chats from your current app.</p>
              </div>
            </li>
            <li>
              <span class="step-num">2</span>
              <div>
                <strong>Download</strong>
                <p>Download the new APK from this website.</p>
              </div>
            </li>
            <li>
              <span class="step-num">3</span>
              <div>
                <strong>Install</strong>
                <p>Install over the current version when your device allows it.</p>
              </div>
            </li>
            <li>
              <span class="step-num">4</span>
              <div>
                <strong>Verify</strong>
                <p>Open the app and check that the version matches {{ app.latestVersion }}.</p>
              </div>
            </li>
          </ol>
        </div>
      </section>

      <section class="content-section muted">
        <div class="page-shell frequency-block">
          <p class="section-kicker">Update timing</p>
          <h2>How Often Is GB WhatsApp Updated?</h2>
          <p>{{ copy.section4 }}</p>
        </div>
      </section>

      <section class="content-section">
        <div class="page-shell">
          <p class="section-kicker">Version history</p>
          <h2>Previous GB WhatsApp Versions</h2>
          <p class="section-lead">
            Looking for an earlier release instead of the latest update? Visit our
            <router-link class="home-text-link" :to="{ name: 'en-old-version' }">
              GB WhatsApp Old Version page
            </router-link>
            to check previous version numbers, review installation precautions, and
            find out what to verify before using an older APK.
          </p>
          <ul class="version-summary">
            <li><strong>Current version:</strong> {{ app.latestVersion }}</li>
            <li><strong>Previous version:</strong> v18.70</li>
            <li><strong>Older version:</strong> v18.60</li>
          </ul>
          <p class="version-summary-note">
            Historical version entries are provided for reference. Download
            availability depends on whether a corresponding APK file is available.
          </p>
        </div>
      </section>

      <section class="content-section muted">
        <div class="page-shell">
          <p class="section-kicker">Update FAQ</p>
          <h2>FAQ About GB WhatsApp Updates</h2>
          <p class="section-lead">{{ copy.section6Intro }}</p>
          <div class="faq-list">
            <details
              v-for="(faq, idx) in faqs"
              :key="faq[0]"
              class="faq-item"
              :open="idx === 0"
            >
              <summary>{{ faq[0] }}</summary>
              <p>{{ faq[1] }}</p>
            </details>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import BreadcrumbNav from '@/components/BreadcrumbNav.vue'
import {
  appInfo,
  updateHighlights,
  updateFaqs,
  updateCopy,
} from '@/content/gbwapps'
import { DOWNLOAD_APK_URL } from '@/config/site'
import '@/css/base.scss'

export default {
  name: 'UpdatePage',
  components: {
    HeadNav,
    BreadcrumbNav,
  },
  data() {
    return {
      app: appInfo,
      highlights: updateHighlights,
      faqs: updateFaqs,
      copy: updateCopy,
      downloadUrl: DOWNLOAD_APK_URL,
    }
  },
}
</script>

<style lang="scss" scoped>
.gb-page {
  background: #ffffff;
  color: #111111;
  font-family: 'Lora', Georgia, serif;
  font-size: 16px;
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
}

.page-shell {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
}

.update-hero {
  position: relative;
  padding: 48px 0 56px;
  border-bottom: 1px solid #dce9e2;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 18% 20%, rgba(22, 163, 74, 0.16), transparent 34%),
    radial-gradient(circle at 88% 12%, rgba(16, 37, 28, 0.1), transparent 28%),
    linear-gradient(180deg, #eefaf2 0%, #ffffff 72%);
  pointer-events: none;
}

.hero-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.7fr);
  gap: 28px;
  align-items: center;
}

.eyebrow {
  margin: 0 0 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
}

.eyebrow-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #16a34a;
}

.hero-lead {
  margin: 14px 0 0;
  max-width: 640px;
  color: #33443b;
}

h1 {
  margin: 0;
  max-width: 760px;
  color: #000000;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 34px;
  font-weight: 400;
  line-height: 1.2;
}

h2 {
  margin: 0 0 14px;
  color: #000000;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.25;
}

h3 {
  margin: 0 0 8px;
  color: #111111;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.3;
}

p {
  color: #222222;
  line-height: 1.625;
}

.home-text-link {
  color: #0f8f43;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.section-kicker {
  margin: 0 0 8px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.section-lead {
  margin: 0 0 22px;
  max-width: 820px;
}

.primary-btn,
.table-btn,
.card-link {
  min-height: 48px;
  padding: 0 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #16a34a;
  color: #ffffff;
  text-decoration: none;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  box-shadow: 0 10px 22px rgba(22, 163, 74, 0.24);
}

.primary-btn {
  margin-top: 20px;
}

.update-card {
  padding: 28px 24px;
  border: 1px solid #d7e8de;
  border-radius: 16px;
  background: linear-gradient(180deg, #10251c 0%, #163528 100%);
  color: #ffffff;
  box-shadow: 0 18px 40px rgba(16, 37, 28, 0.18);

  span {
    display: block;
    color: #8fd9ae;
    font-family: 'Oswald', Arial, sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    font-size: 13px;
  }

  strong {
    display: block;
    margin: 10px 0 6px;
    color: #ffffff;
    font-family: 'Oswald', Arial, sans-serif;
    font-weight: 400;
    font-size: 32px;
  }

  p {
    margin: 0 0 18px;
    color: #d7e8de;
  }
}

.card-link {
  width: 100%;
  min-height: 44px;
  box-sizing: border-box;
}

.content-section {
  padding: 56px 0;
}

.muted {
  background: #f6faf8;
}

.split-section {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 0.72fr);
  gap: 30px;
  align-items: start;
}

.info-panel {
  border: 1px solid #dce9e2;
  border-radius: 14px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 14px 28px rgba(16, 37, 28, 0.06);
}

.info-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  background: #10251c;
  color: #ffffff;

  p {
    margin: 0;
    color: #8fd9ae;
    font-family: 'Oswald', Arial, sans-serif;
    font-size: 13px;
    text-transform: uppercase;
  }

  strong {
    font-family: 'Oswald', Arial, sans-serif;
    font-weight: 400;
    font-size: 20px;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 14px 16px;
  border-bottom: 1px solid #e5ece8;
  text-align: left;
}

th {
  width: 45%;
  background: #f6faf8;
  color: #294038;
}

tr:last-child th,
tr:last-child td {
  border-bottom: 0;
}

.table-btn {
  margin: 16px;
  min-height: 46px;
}

.highlight-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.highlight-card {
  position: relative;
  padding: 22px 20px 20px;
  background: #ffffff;
  border: 1px solid #d7e8de;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 37, 28, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  p {
    margin: 0;
    color: #40554c;
  }
}

.highlight-card:hover {
  transform: translateY(-3px);
  border-color: #98d0b2;
  box-shadow: 0 16px 28px rgba(16, 37, 28, 0.08);
}

.highlight-index {
  display: inline-block;
  margin-bottom: 10px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 13px;
}

.steps-section {
  background:
    radial-gradient(circle at 12% 20%, rgba(22, 163, 74, 0.08), transparent 36%),
    linear-gradient(180deg, #ffffff 0%, #f7fcf9 100%);
}

.steps-header {
  margin-bottom: 24px;
}

.update-panel {
  margin: 0;
  padding: 22px;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  border: 1px solid #d7e8de;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fcf9 100%);
  box-shadow: 0 14px 30px rgba(16, 37, 28, 0.06);
}

.update-panel li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin: 0;
  padding: 16px 14px;
  border: 1px solid #e5ece8;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(16, 37, 28, 0.04);
}

.update-panel strong {
  display: block;
  margin-bottom: 6px;
  color: #10251c;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 15px;
  font-weight: 400;
  text-transform: uppercase;
}

.update-panel p {
  margin: 0;
  color: #33443b;
  font-size: 14px;
  line-height: 1.5;
}

.step-num {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #16a34a;
  color: #ffffff;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 15px;
  box-shadow: 0 8px 16px rgba(22, 163, 74, 0.28);
}

.frequency-block {
  max-width: none;
  padding: 28px;
  border: 1px solid #d7e8de;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(16, 37, 28, 0.05);

  p:last-child {
    margin-bottom: 0;
  }
}

.version-summary {
  margin: 0 0 14px;
  padding-left: 22px;
  color: #294038;

  li {
    margin-bottom: 8px;
  }
}

.version-summary-note {
  margin: 0;
  max-width: 820px;
  color: #40554c;
}

.version-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.version-item {
  display: grid;
  gap: 8px;
  padding: 20px 18px;
  border: 1px solid #dce9e2;
  border-radius: 14px;
  color: #1c2b24;
  text-decoration: none;
  background: #ffffff;
  box-shadow: 0 10px 22px rgba(16, 37, 28, 0.05);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  strong {
    font-family: 'Oswald', Arial, sans-serif;
    font-size: 22px;
    font-weight: 400;
  }

  span:last-child {
    color: #40554c;
    font-size: 14px;
  }
}

.version-item:hover {
  transform: translateY(-3px);
  border-color: #98d0b2;
  box-shadow: 0 16px 28px rgba(16, 37, 28, 0.08);
}

.version-item.current {
  border-color: #16a34a;
  background: linear-gradient(180deg, #f3fbf6 0%, #ffffff 100%);
}

.version-tag {
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eefaf2;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 12px;
  text-transform: uppercase;
}

.version-item.current .version-tag {
  background: #16a34a;
  color: #ffffff;
}

.faq-list {
  display: grid;
  gap: 12px;
}

.faq-item {
  border: 1px solid #dce9e2;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.faq-item summary {
  list-style: none;
  cursor: pointer;
  padding: 18px 20px;
  color: #111111;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 1.35;
}

.faq-item summary::-webkit-details-marker {
  display: none;
}

.faq-item[open] summary {
  border-bottom: 1px solid #e5ece8;
  background: #f7fcf9;
}

.faq-item p {
  margin: 0;
  padding: 16px 20px 20px;
  color: #33443b;
}

@media (max-width: 980px) {
  .hero-grid,
  .split-section,
  .highlight-grid,
  .version-list,
  .update-panel {
    grid-template-columns: 1fr;
  }

  h1 {
    font-size: 28px;
  }
}

@media (max-width: 720px) {
  .update-panel {
    padding: 14px;
  }
}
</style>
